import { PrismicRichText } from '@prismicio/react';
import Plyr from 'plyr';
import { useEffect, useRef } from 'react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper as SectionWrapperRaw } from 'remote-com-shared/components/SectionWrapper';
import { transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { fieldHasContent } from '@/src/domains/prismic/helpers';
import 'plyr/dist/plyr.css';

const SectionWrapper = styled(SectionWrapperRaw)`
  background: var(--colors-blank);
  text-align: left;
  ${fluidProp(['padding-top', 'padding-bottom'], '32px', '64px')}
`;

export const VideoWrapper = styled.div`
  ${fluidProp('margin-top', '36px', '64px')}
  margin: auto;
  max-width: 960px;
  position: relative;

  .plyr__control--overlaid {
    background: var(--colors-irisBlue);
  }
  .plyr--full-ui input[type='range'] {
    color: var(--colors-irisBlue);
  }
  .plyr__control {
    &:hover {
      background: var(--colors-irisBlue);
    }
  }
`;

export const Video = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const Title = styled.div`
  font-size: 36px;
  font-family: var(--typography-fontBrand);
  color: var(--newBrandColor);
  font-weight: 700;
  line-height: 1.135;
  margin-bottom: 28px;

  > * {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: 0;
  }
`;

const Description = styled.div`
  font-family: var(--typography-fontBrand);
  ${({ theme }) => theme.typography.titleSM}
  color: rgba(20, 25, 30, 0.75);
  font-weight: 400;
  line-height: 1.55;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const VideoEmbed = ({ videoId }) => {
  const plyrRef = useRef(null);

  useEffect(() => {
    if (!plyrRef.current) return;

    plyrRef.current.plyr = new Plyr(`#player-js-${videoId}`, { captions: { active: true } });

    plyrRef.current.dataset.plyrEmbedId = videoId;
  }, [plyrRef, videoId]);

  return (
    <VideoWrapper>
      <Video data-plyr-provider="vimeo" ref={plyrRef} id={`player-js-${videoId}`} />
    </VideoWrapper>
  );
};

export function VideoEmbedSlice({ slice }) {
  const { primary } = transformProperties(slice);

  const { videoEmbedLink, title, description } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(description) && (
          <Description>
            <PrismicRichText field={description} />
          </Description>
        )}
        <VideoEmbed videoId={videoEmbedLink} />
      </ContentContainer>
    </SectionWrapper>
  );
}
